module.exports = __webpack_public_path__ + "static/img/blue.2c82618a.gif";